import _ from 'lodash';
/**
 * Check session storage has updated_location key
 */
export const sessionStorageHasUpdatedLocation = () =>{
    return _.has(sessionStorage, 'updated_location')
}
/**
 * Set updated location in session storage
 */
export const sessionStorageSetUpdatedLocation = () => {
    sessionStorage.setItem('updated_location', true);
}